import getRecentPeriod from "./get-recent-period";

export default function getRecentVolume({ state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  return getRecentPeriod(state.container.volumes);
}
